import Reflux from 'reflux'
import QueryActions from '../actions/QueryActions'

export var SortDirectionStore = Reflux.createStore(
{
	init:function()
	{
		this.listenTo(QueryActions.updateSortDirection,'onUpdateSortDirection');
	},
    onUpdateSortDirection(groupAlias,arg)
    {
		this.trigger(groupAlias,arg);
    }
});

export var HeaderClickSortStore = Reflux.createStore(
{
	init:function() {
		this.listenTo(QueryActions.gridHeaderClickSort,'onGridHeaderClickSort');
	},
	onGridHeaderClickSort(columnKey,sortDirection,moduleInstanceId){
		this.trigger(columnKey,sortDirection,moduleInstanceId);
	}
});

export var AutoFormLookupHeaderClickSortStore = Reflux.createStore(
{
	init:function()
	{
		this.listenTo(QueryActions.autoFormLookupGridHeaderClickSort,'onAutoFormLookupGridHeaderClickSort');
	},
	onAutoFormLookupGridHeaderClickSort(columnKey,sortDirection,moduleInstanceId)
	{
		this.trigger(columnKey,sortDirection,moduleInstanceId);
	}

});



// WEBPACK FOOTER //
// ./src/stores/QueryStores.js